import { CustomColumn } from '../../../types/customColumn';
import { InventoryTransferTableDTO } from '../../../types/inventory/transfer/InventoryTransferTypes';
import { getTransferStatusBadgeColor } from '../../../utils/inventory/statusBadgeColor';

export const inventoryTransferColumns: CustomColumn<InventoryTransferTableDTO>[] =
  [
    {
      Header: 'Productos',
      accessor: 'productCount',
      customCell: ({ row }) => (
        <span className="text-sm font-semibold text-black dark:text-white">
          {row.original.productCount}
        </span>
      ),
    },

    {
      Header: 'Origen',
      accessor: 'originBranchName',
      customCell: ({ row }) => (
        <span className="text-gray-700 dark:text-gray-300 text-sm">
          {row.original.originBranchName}
        </span>
      ),
    },

    {
      Header: 'Destino',
      accessor: 'destinationBranchName',
      customCell: ({ row }) => (
        <span className="text-gray-700 dark:text-gray-300 text-sm">
          {row.original.destinationBranchName}
        </span>
      ),
    },

    // ===============================================
    // 🔵 Estado (en español, con badge coloreado)
    // ===============================================
    {
      Header: 'Estado',
      accessor: 'status',
      customCell: ({ row }) => {
        const status = row.original.status;
        const colors = getTransferStatusBadgeColor(status);

        return (
          <span className={`rounded-md px-2 py-1 text-xs font-bold ${colors}`}>
            {status}
          </span>
        );
      },
    },

    // ===============================================
    // 📅 Fecha + 🕒 Hora (separadas)
    // ===============================================
    {
      Header: 'Fecha Solicitud',
      accessor: 'requestedDate',
      customCell: ({ row }) => (
        <div className="flex flex-col text-sm leading-tight">
          <span className="text-gray-800 dark:text-gray-200 font-medium">
            {row.original.requestedDate}
          </span>

          <span className="text-gray-500 dark:text-gray-400 text-xs">
            {row.original.requestedTime}
          </span>
        </div>
      ),
    },
  ];
